import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=10c6848f&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c6848f')) {
      api.createRecord('10c6848f', component.options)
    } else {
      api.reload('10c6848f', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=10c6848f&", function () {
      api.rerender('10c6848f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-292wdwe49gjLJ/JS/offershelp.vue"
export default component.exports